import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    this.start = this.start.bind(this);
    this.stop = this.stop.bind(this);

    this.form = this.element.form;
    if (this.form) {
      this.form.addEventListener('turbo:submit-start', this.start);
      this.form.addEventListener('turbo:submit-end', this.stop);
    }
  }

  disconnect() {
    if (this.form) {
      this.form.removeEventListener('turbo:submit-start', this.start);
      this.form.removeEventListener('turbo:submit-end', this.stop);
    }
  }

  start() {
    this.element.setAttribute('aria-busy', 'true');
  }

  stop() {
    this.element.removeAttribute('aria-busy');
  }
}
